module.exports = __webpack_public_path__ + "img/analytic_2.76f5d1a0.jpg";